import { ChangeEvent, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, Container, Typography, Stack, TextField, Box } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import axios from "axios";
import { toast } from "react-toastify";
import { Icon } from "@iconify/react";

import { API_URL } from "Constants";

import VirastyLogo from "Assets/Contact/Virasty.svg";

export default function Contact() {
  const navigate = useNavigate();

  const [formData, setFormData] = useState<{ [key: string]: any }>({});
  const [requesting, setRequesting] = useState<boolean>(false);

  const submit = (e: any) => {
    e.preventDefault();

    let form = new FormData();
    Object.keys(formData).forEach((key) => {
      form.append(key, formData[key]);
    });

    setRequesting(true);
    axios
      .post(`${API_URL}/contact-us/create`, form)
      .then((res) => {
        toast.success("با موفقیت ثبت شد");
        setTimeout(() => {
          navigate("/");
        }, 1000);
        setRequesting(false);
      })
      .catch((err) => {
        toast.error("مشکلی در ثبت درخواست پیش آمد");
        setRequesting(false);
      });
  };
  const handleInput = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <Container maxWidth="md">
      <Card sx={{ p: 3 }}>
        <Stack spacing={3}>
          <Typography align="center" variant="h5" sx={{ color: "secondary.main", fontWeight: "600" }}>
            تماس با ما
          </Typography>

          <form onSubmit={submit}>
            <Stack spacing={3} alignItems="center">
              <Stack spacing={1} sx={{ width: "100%" }}>
                <Typography sx={{ color: "secondary.main" }}>نام شما</Typography>
                <TextField variant="filled" type="text" fullWidth onChange={handleInput} name="user_name" />
              </Stack>
              <Stack spacing={1} sx={{ width: "100%" }}>
                <Typography sx={{ color: "secondary.main" }}>عنوان پیام</Typography>
                <TextField variant="filled" type="text" fullWidth onChange={handleInput} name="message_title" />
              </Stack>

              <Stack spacing={1} sx={{ width: "100%" }}>
                <Typography sx={{ color: "secondary.main" }}>متن پیام</Typography>
                <TextField variant="filled" type="text" multiline rows={4} fullWidth onChange={handleInput} name="message_text" />
              </Stack>

              <LoadingButton
                variant="contained"
                loading={requesting}
                onClick={submit}
                color="secondary"
                sx={{ width: "200px", py: 1.5 }}
              >
                ارسال پیام
              </LoadingButton>
            </Stack>
          </form>
        </Stack>

        <Stack direction="row" alignItems="center" spacing={2} sx={{ width: "100%", mt: 5 }}>
          <Box sx={{ flexGrow: 1, height: "3px", bgcolor: "secondary.main" }} />
          <Stack direction="row" alignItems="center" spacing={1} sx={{ color: "secondary.main" }}>
            <a href="">
              <Box
                sx={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "50%",
                  bgcolor: "secondary.main",
                  display: "grid",
                  placeItems: "center",
                }}
              >
                <img src={VirastyLogo} width="22px" />
              </Box>
            </a>

            <a href="mailto:Support@anti403.ir">
              <Box
                sx={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "50%",
                  bgcolor: "secondary.main",
                  display: "grid",
                  placeItems: "center",
                }}
              >
                <Icon icon="ic:outline-email" fontSize="25px" color="#fff" />
              </Box>
            </a>
          </Stack>

          <Box sx={{ flexGrow: 1, height: "3px", bgcolor: "secondary.main" }} />
        </Stack>
      </Card>
    </Container>
  );
}
